import { useEffect, useReducer } from 'react';
import reducer from './reducer';
import getActions from './getActions';
import { IUnderwritersState } from '@/creditflowresearch/application/League/interfaces';
import { useLeagueTableFiltersContext } from '@/creditflowresearch/application/League/Table/LeagueTableFiltersContext';

interface IProps {
  underwritersInitialState: IUnderwritersState,
}

export default ({ underwritersInitialState }:IProps) => {
  const [state, dispatch] = useReducer(reducer, underwritersInitialState);
  const { page, perPage } = state;
  const { state: filtersState } = useLeagueTableFiltersContext();
  const selectedPeriod = filtersState.periods.leagueTable.selected;
  const searchText = filtersState.search.value;

  const actions = getActions({ page, perPage, selectedPeriod, searchText }, dispatch);

  useEffect(() => {
    const { data: collection, totalCount } = underwritersInitialState;

    actions.setUnderwritersData({ collection, totalCount });
  }, [underwritersInitialState]);

  return {
    state,
    ...actions,
  };
};
